import { ChainId, ERC20Token, WETH9 } from '@nominex/nomiswap-sdk'
import { ERC20TokensMap } from './types'

export const tokens: ERC20TokensMap = {
  abra: new ERC20Token(
    ChainId.ARBITRUM,
    '0x65114046C6e73AF794308547124aD5C8dcE3be6F',
    18,
    'ABRA',
    'Cadabra Finance',
    'https://cadabra.finance/',
  ),
  busd: new ERC20Token(
    ChainId.ARBITRUM,
    '0x52095F518048fAFCfba0Ec9F93962df449Bc604e',
    18,
    'BUSD',
    'Binance USD',
    'https://www.paxos.com/busd/',
  ),
  nmx: new ERC20Token(
    ChainId.ARBITRUM,
    '0x6Ec214fdDa5C5eD2d6CCc9Cc5BDD7F6Ef76DF6D9',
    18,
    'NMX',
    'Nominex Token',
    'https://nominex.io/',
  ),
  usdc: new ERC20Token(ChainId.ARBITRUM, '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8', 6, 'USDC', 'USD Coin'),
  usdt: new ERC20Token(
    ChainId.ARBITRUM,
    '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    6,
    'USDT',
    'Tether USD',
    'https://tether.to/',
  ),
  weth: WETH9[ChainId.ARBITRUM],
}
